import React from 'react';
import { displayName } from '../../../App';
import Content from '../../components/Pages/UnreviewedDoc';
import MainGuidanceLayout from '../../components/Layout/Main';

function UnreviewedDoc() {
  document.title = `${displayName}: Unreviewed Document`;

  return (
    <MainGuidanceLayout>
      <Content />
    </MainGuidanceLayout>
  );
}

export default UnreviewedDoc;
